import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import aurganon from "../assets/aurganon.png";
import scholar from "../assets/scholar.png";
import cyber from "../assets/cyber.png";

// Card Component Implementation
const Card = ({ className, children, ...props }) => {
  return (
    <div
      className={`rounded-lg border bg-card text-card-foreground shadow-sm ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

const WallOfFame = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const achievements = [
    { image: aurganon, title: "CODECRAFT -AURGANON'24", description: "In recognition of my outstanding achievement, I am honored to have clinched FIRST PLACE at the prestigious national Code Craft competition, Aurganon 2024. Despite being a first-year student, I showcased exemplary coding skills in frontend development, Node.js, and React, surpassing seasoned peers. This victory reflects my dedication, perseverance, and ability to excel under pressure. Awarded with a medal, certificate, cash prize of Rs. 1000, brand vouchers, and a cherished souvenir, this accomplishment signifies not only my individual success but also the power of effective teamwork.", imageAlt: "Aurganon" },
    { image: scholar, title: "Recipient of Scholar of the Year Title by Tata Co-operative Society", description: "I am honored to have received the Scholar of the Year award from Tata Motors Society. This prestigious recognition includes a certificate, a gold medal, and a check for 4,000. The award highlights my achievements as the top student in 12th grade, acknowledging both my academic excellence and my active participation in extracurricular activities.", imageAlt: "Tata Co-operative society" },
    { image: cyber, title: "First Place at AI-Cyber Quest: Secure File-Sharing System Development", description: "Honored with 1st place at the AI-Cyber event, a solo hackathon organized by the college club at SRMIST Ramapuram. I independently developed a secure file-sharing system web application, earning top recognition for my innovative and effective solution. This achievement was celebrated with exciting vouchers and a certificate.", imageAlt: "AI Quest" }
  ];

  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex + 1 >= achievements.length ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex - 1 < 0 ? achievements.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className="min-h-screen bg-[#50C878] p-2">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-4xl md:text-5xl font-bold text-center mb-4 md:mb-8 tracking-wider text-black">
          AWARDS AND HONOUR
        </h1>

        <div className="relative px-4 md:px-16">
          {/* Navigation Buttons */}
          <button
            onClick={prevSlide}
            className="absolute left-0 top-1/2 -translate-y-1/2 bg-white rounded-full p-2 md:p-3 shadow-lg hover:bg-gray-100 transition-colors z-10"
          >
            <ChevronLeft size={20} />
          </button>

          <button
            onClick={nextSlide}
            className="absolute right-0 top-1/2 -translate-y-1/2 bg-white rounded-full p-2 md:p-3 shadow-lg hover:bg-gray-100 transition-colors z-10"
          >
            <ChevronRight size={20} />
          </button>

          {/* Single Card Container */}
          <div className="max-w-4xl mx-auto">
            <Card
              className="bg-white border-2 border-black overflow-hidden transition-transform h-auto md:h-[800px] w-full"
            >
              <div className="p-3 md:p-6">
                <div className="aspect-square relative mb-2 md:mb-4 p-1 md:p-2 h-[300px] sm:h-[400px] md:h-[500px] lg:h-[600px] w-full">
                  <img
                    src={achievements[currentIndex].image}
                    alt={achievements[currentIndex].imageAlt}
                    className="w-full h-full object-cover rounded-lg border-2 border-black contain"
                  />
                </div>
                <div className="text-center h-auto md:h-[100px] overflow-y-auto">
                  <h3 className="font-medium text-xl md:text-2xl mb-1 md:mb-2">
                    {achievements[currentIndex].title}
                  </h3>
                  <p className="text-gray-600 text-xs md:text-sm max-h-[150px] md:max-h-none overflow-y-auto">
                    {achievements[currentIndex].description}
                  </p>
                </div>
              </div>
            </Card>
          </div>

          {/* Navigation Dots */}
          <div className="flex justify-center mt-2 gap-2">
            {achievements.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-2 h-2 md:w-3 md:h-3 rounded-full transition-colors ${
                  currentIndex === index ? 'bg-white' : 'bg-gray-300'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WallOfFame;